var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-json-pretty',{attrs:{"path":'',"deep":1,"data":_vm.jsonDefaults},on:{"click":_vm.jsonClick}})}
var staticRenderFns = []

export { render, staticRenderFns }